export const versionInfo = {
  commit: '7e32ff63',
  version: '7e32ff63'
};
